module.exports = function encodeQueryParams(params) {
    if (params) {
        let encodedParams = [];
        for (let key in params) {
            if (!!params[key]) {
                encodedParams.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
            }
        }
        if (encodedParams.length) {
            return '?' + encodedParams.join('&');
        }
    }
    return '';
};
